import { render, staticRenderFns } from "./EmployeeLeavePolicies.vue?vue&type=template&id=a56a14a2"
import script from "./EmployeeLeavePolicies.vue?vue&type=script&lang=js"
export * from "./EmployeeLeavePolicies.vue?vue&type=script&lang=js"
import style0 from "./EmployeeLeavePolicies.vue?vue&type=style&index=0&id=a56a14a2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports